import { GeocodeRequest } from './types';
import * as googleMapsUtils from './googleMapsUtils';
import { formatAddressOutput } from './google2address';

// todo: add test
export const useGoogleMapsGeocodeHandler = (
  apiKey: string,
  lang: string,
  country: string | undefined,
) => {
  const getGeocode = async (request: GeocodeRequest) => {
    const { placeId, rawInputValue } = request;
    const newRequest = placeId
      ? { placeId, region: country }
      : { address: rawInputValue };
    const result = await googleMapsUtils.geocode(apiKey, lang, newRequest);
    return result.length > 0
      ? formatAddressOutput(result[0], rawInputValue)
      : { formatted: rawInputValue };
  };

  return { getGeocode };
};
